import { z } from "zod";
import { BaseAnalyticsEvent } from "./base";
export const Paywall_Create = BaseAnalyticsEvent.extend({
    name: z.literal("Paywall_Create"),
    properties: z.object({
        from: z.enum([
            "url",
            "scratch",
            "legacy-templates",
            "duplicate",
            "scratch-v4"
        ])
    })
});
export const Paywall_Update = BaseAnalyticsEvent.extend({
    name: z.literal("Paywall_Update")
});
// TODO: Add in the tracking for this
export const Paywall_Preview = BaseAnalyticsEvent.extend({
    name: z.literal("Paywall_Preview")
});
